module.exports = __webpack_public_path__ + "static/media/text-3.47f1e877.png";